export default __webpack_public_path__ + "47de9357934b1ce4690c63acab129f6d.png";